import React from "react";

export function InitialsAvatarSkeleton({ className = "", ...other }) {
  return (
    <div {...other} className={`animate-pulse ${className}`}>
      <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-300"></span>
    </div>
  );
}
